import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    padding: "16px 0px 16px 12px",
    border: "1.5px solid #E7E6E4",
    borderRadius: "8px",
    "& *": {
      fontFamily: "unset",
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  scheduled: {
    color: "#F4B64E",
    fontSize: "14px",
  },
  content: {
    width: "100%",
  },
  leftContainer: {
    flex: 1,
  },
  rightContainer: {
    marginTop: "-12px",
  },
  campaignStep: {
    borderRadius: "14px",
    fontSize: "12px",
    padding: "6px",
    textAlign: "center",
    color: theme?.palette?.basic?.white,
  },
  campaignAdded: {
    background: theme?.palette?.primary?.shade_500,
  },
  campaignProcessing: {
    background: theme?.palette?.butterscotch_yellow?.shade_500,
  },
  campaignFailed: {
    background: theme?.palette?.basic?.danger_red,
  },
  campaignCompleted: {
    background: theme?.palette?.fine_pine?.shade_500,
  },
  timeContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  campaignDataContainer: {
    display: "flex",
    gap: "6px",
    marginRight: "16px",
    alignItems: "center",
  },
  mailTo: {
    display: "flex",
    gap: "20px",
    fontWeight: 500,
    cursor: "pointer",

    "&:hover": {
      color: theme?.palette?.primary?.main,
    },
    marginBottom: ({ type }) => type !== "past" && "10px",
    borderBottom: ({ type }) => type !== "past" && "2px solid #E7E6E4",
  },
  recipients: {
    color: "#272522",
    fontSize: "16px",
    fontWeight: 500,
    textDecoration: "underline",
    marginBottom: "12px",
    cursor: "pointer",
    maxWidth: "50vw",

    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "&:hover": {
      color: theme?.palette?.primary?.main,
    },
  },
  bottomDataContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  subject: {
    color: "#272522",
    fontSize: "16px",
    marginBottom: "10px",
  },
  emailIcon: {
    height: "24px",
    width: "24px",
    paddingBottom: "12px",
    paddingRight: "12px",
    boxSizing: "content-box",
    borderBottom: ({ type }) => type !== "past" && "2px solid #E7E6E4",
  },
  copyIcon: {
    height: "18px",
  },
  copyIconDisabled: {
    "& path": {
      fill: "rgba(0, 0, 0, 0.26) !important",
    },
  },
  iconButton: {
    padding: "12px",
  },
  deleteIcon: {
    "& :hover": {
      color: theme?.palette?.basic?.danger_red,
    },
  },
  divider: {
    border: "none",
    height: "2px",
    background: "#E7E6E4",
    margin: "10px 0px",
  },
  itemData: {
    fontSize: "16px",
    fontWeight: 700,
    marginBottom: "8px",
  },
  itemTitle: {
    fontSize: "16px",
    color: "#272522",
  },
  horizontalDivider: {
    width: "1.5px",
    background: "#C4C4C4",
  },
  dataContainer: {
    display: "flex",
    gap: "16px",
  },
  sentTo: {
    color: "#493AB1",
  },
  deliveredTo: {
    color: "#EDB183",
  },
  openedBy: {
    color: "#00B77A",
  },
  openedRate: {
    color: "#0052CC",
  },
  dark: {
    background: "#F3F2F1",
  },
  scheduledPrefix: {
    color: "#FFAA00",
  },
  chip: {
    height: "23px",
    display: "flex",
    alignItems: "center",
    fontSize: "12px",
    padding: "0px 6px",
    borderRadius: "11.5px",
    textDecoration: "none",
  },
  draftChip: {
    background: "#F7D6D4",
    color: "#AA2822",
  },
  scheduledChip: {
    background: "#FFEECC",
    color: "#FFAA00",
  },
  iconContainer: {
    borderBottom: ({ type }) => type !== "past" && "2px solid #E7E6E4",
  },
}));
